export default "__VITE_ASSET__B$kQI8F$__"